module.exports = __webpack_public_path__ + "Roboto-Regular-webfont.7f1320f7ec4f6716054d.ttf";


//////////////////
// WEBPACK FOOTER
// C:/Disco D/Projetos/central-cliente/src/assets/fonts/roboto/Roboto-Regular-webfont.ttf
// module id = ../../../../../src/assets/fonts/roboto/Roboto-Regular-webfont.ttf
// module chunks = 2